import React from 'react';

import { observer } from 'mobx-react';
import { ManualTriggerInputParam, ManualTriggerParamDataType } from '@bringg/types';
import { useTranslation } from 'react-i18next';
import { configurationContentProvider } from '@bringg-frontend/bringg-web-legacy/automation-platform';
import { DynamicFormModal, DynamicFormStringType, FormFields } from '@bringg-frontend/dynamic-form-modal';
import { UserSelectorMode } from '@bringg/react-components';

interface ManualTriggerDynamicFormModalProps {
	onClose: () => void;
	onSubmit: (values?: any) => void;
	name: string;
	vars?: ManualTriggerInputParam[];
}

const ManualTriggerFormModal = ({ name, vars, onClose, onSubmit }: ManualTriggerDynamicFormModalProps) => {
	const { t } = useTranslation();

	const formFields: FormFields[] = (vars || []).map(field => {
		const control = configurationContentProvider.getFieldControl(field.data_type);

		const formField: FormFields = {
			key: field.name,
			label: field.name,
			control,
			mandatory: field.data_type !== ManualTriggerParamDataType.BOOLEAN
		};

		switch (field.data_type) {
			case ManualTriggerParamDataType.BOOLEAN:
				formField.valuePropName = 'checked';
				break;
			case ManualTriggerParamDataType.NUMBER:
				formField.type = DynamicFormStringType.number;
				break;
			case ManualTriggerParamDataType.STRING:
				formField.type = DynamicFormStringType.string;
				break;
			case ManualTriggerParamDataType.DRIVER:
				formField.mode = UserSelectorMode.single;
				break;
			case ManualTriggerParamDataType.DATETIME:
				formField.use12Hours = true;
				formField.timeFormat = 'hh:mm';
				break;
		}

		return formField;
	});

	return (
		<DynamicFormModal
			title={name}
			okText={t('AUTOMATION.TRIGGER.MANUAL.MODAL.RUN')}
			cancelText={t('GLOBAL.CANCEL')}
			onClose={onClose}
			onSubmit={values => {
				onSubmit(values);
			}}
			destroyOnClose
			visible
			formFields={formFields}
		/>
	);
};

export default observer(ManualTriggerFormModal);
